import {writable} from "svelte/store";

export const referenceLanguages = writable([])
export const referenceCountries = writable([])
export const referenceEducation = writable([])
export const referenceGraduation = writable([])